import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PolicyCollectiveLife } from '@models/policy-collective-life';
import { Observable } from 'rxjs';
import { MMobileService } from '../../../core/services/common';
import { BaseService } from '../core/base.service';
import { OperationRegisterService } from '../core/operation-register.service';
@Injectable({
  providedIn: 'root'
})
export class CollectiveLifePoliciesService {
  constructor(
    private http: HttpClient,
    private mmobile: MMobileService,
    private base: BaseService,
    private or: OperationRegisterService
  ) {}

  getCollectiveLifePolicy(
    policy: PolicyCollectiveLife
  ): Observable<PolicyCollectiveLife> {
    const { policyNumber, subpolicyNumber, type } = policy;
    let url = `${this.base.getPrivateOIMBaseUrl()}/lifePolicies/${policyNumber}/collective?type=${type}`;
    if (subpolicyNumber) {
      url += `&subpolicyNumber=${subpolicyNumber}`;
    }
    const headers = this.base.getPrivateOIMHeaders({ cacheResponse: true });
    return this.http.get<PolicyCollectiveLife>(url, headers);
  }

  getCollectivePolicyBondDocument(policy: PolicyCollectiveLife) {
    const { policyNumber, bondId, bondPage } = policy;
    const url = `${this.base.getPrivateOIMBaseUrl()}/lifePolicies/${policyNumber}/documents/bonds/${bondId}?bondPage=${bondPage}&isCollective=true`;
    const params = this.or.setCollectiveLifeOperationParams(policy);
    return this.http.get<Document>(url, {
      ...this.base.getPrivateOIMHeaders({ cacheResponse: true }),
      params
    });
  }
}
